// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { getIconPath } from '@tcp/core/src/utils/utils';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { isMobileWeb } from '@tcp/core/src/utils';
import PageHeadingWithLinks from '../../common/molecule/PageHeadingWithLinks';
import MyRewards from '../../common/organism/MyRewards';
import Anchor from '../../../../common/atoms/Anchor';
import BodyCopy from '../../../../common/atoms/BodyCopy';
import MyOffersCoupons from '../../common/organism/MyOffersCoupons';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import WalletLabels, { CHECKOUT_BAGPAGE, GLOBAL_PLACE_REWARDS } from '../container/Wallet.lables';
import {
  GlobalActionsLabels,
  GLOBAL_ACTIONS_LABELS,
  lblBack,
} from '../../../../../utils/labels/globalActions.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblProgramDetails,
  lblTnc,
} from '../../../../../utils/labels/globalGeneric.labels';

const WalletView = ({ onDrawerClose, isWalletCouponRedesign }) => {
  const placeRewardsLabels = getLabelFromCopyOrFromTranslation(GLOBAL_PLACE_REWARDS, WalletLabels);
  const bagPageLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_BAGPAGE, WalletLabels);

  const walletContainerStyle = { display: 'flex' };
  return (
    <>
      <BodyCopy component="div" className="elem-mb-MED account-dashboard-goback-link">
        <Anchor
          fontSizeVariation="xlarge"
          anchorVariation="secondary"
          to="/account?id=account-overview"
          asPath="/account"
        >
          <span className="left-arrow" />
          {renderLabel(
            getLabelFromCopyOrFromTranslation(
              `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
              GlobalActionsLabels
            ),
            'lbl_back'
          )}
        </Anchor>
      </BodyCopy>
      <div className="wallet-header-container" style={walletContainerStyle}>
        {isWalletCouponRedesign && (
          <Image alt="wallet-icon" src={getIconPath('offers-wallet')} width="24" height="24" />
        )}
        <BodyCopy
          fontFamily="secondary"
          fontSize={isMobileWeb() ? 'fs16' : 'fs20'}
          fontWeight="bold"
          component="h2"
          data-locator="offers-heading"
          className={isWalletCouponRedesign ? 'elem-pl-MED' : ''}
        >
          {isWalletCouponRedesign
            ? renderLabel(
                bagPageLabels.lbl_coupon_collapsible_header,
                'lbl_coupon_collapsible_header'
              )?.toUpperCase()
            : renderLabel(placeRewardsLabels.lbl_my_wallet_heading, 'lbl_my_wallet_heading')}
        </BodyCopy>
      </div>
      <PageHeadingWithLinks
        className="myAccountRightView"
        programDetailsCta={renderLabel(
          getLabelFromCopyOrFromTranslation(
            `${GLOBAL_GENERIC_LABELS}.${lblProgramDetails}`,
            GlobalGenericLabels
          ),
          'lbl_program_details'
        )}
        termsConditionCta={renderLabel(
          getLabelFromCopyOrFromTranslation(
            `${GLOBAL_GENERIC_LABELS}.${lblTnc}`,
            GlobalGenericLabels
          ),
          'lbl_tnc'
        )}
      >
        {isWalletCouponRedesign ? (
          <MyOffersCoupons closedOverlay={onDrawerClose} isAccountDashboard isWallet={true} />
        ) : (
          <MyRewards view="all" />
        )}
      </PageHeadingWithLinks>
    </>
  );
};

export default WalletView;
